import React from 'react';
import Reveal from './Reveal';

const steps = [
  {
    num: '01',
    title: 'Point and shoot',
    copy: 'The shutter lives in the tab bar. Five modes - a finished dish, the inside of your fridge, a cookbook page, your pantry shelf, or a meal to log straight into your day.',
  },
  {
    num: '02',
    title: 'Review what it read',
    copy: 'Every scan comes back as an editable draft - quantities, steps, servings. Correct anything before you save it. Nothing is guessed silently.',
  },
  {
    num: '03',
    title: 'Cook it hands-free',
    copy: 'One step per screen, timers that keep running in the background, and voice control so you never touch the phone with dough on your hands.',
  },
];

const HowItWorks = () => (
  <section id="how" className="section" aria-labelledby="how-headline">
    <div className="section-inner">
      <Reveal>
        <div className="eyebrow">How it works</div>
        <h2 id="how-headline" className="h2 section-headline" style={{ maxWidth: '20ch' }}>
          Three taps between a photo and a plated dinner.
        </h2>
        <div className="how-grid">
          {steps.map((step) => (
            <div className="card" key={step.num}>
              <div className="mono step-num">{step.num}</div>
              <h3 className="h3">{step.title}</h3>
              <p className="body-copy">{step.copy}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default HowItWorks;
